module.exports = __webpack_public_path__ + "static/media/cookieIcon.530000d3.png";